export default "__VITE_ASSET__GUtr5QLE__"